// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3SEna","requiredAsterisk":"Info_requiredAsterisk__3eVe9"};